module.exports = __webpack_public_path__ + "static/media/proxy-list.c4054102.svg";